import { createAsyncThunk } from "@reduxjs/toolkit";
import { IShowNotification } from "types/general";
import { API } from "../../config/api";
import { API_ROUTES } from "../../config/apiRoutes";
import { IFeedbackAlert } from "../../types/alert";

/**
 * @description Dispatch this thunk to show a notification.
 */
export const showNotificationThunk = createAsyncThunk<
  IShowNotification,
  IShowNotification
>("alert/showNotificationThunk", async (notification, { rejectWithValue }) => {
  try {
    return notification;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const hideNotificationThunk = createAsyncThunk(
  "alert/hideNotificationThunk",
  async (_, { rejectWithValue }) => {
    return "success";
  },
);

export const sendAlertViaEmail = createAsyncThunk<string, IFeedbackAlert>(
  "alert/sendAlertViaEmail",
  async (reqData, { rejectWithValue }) => {
    try {
      const { data } = await API.post(API_ROUTES.ALERT.SEND_ALERT(), {
        ...reqData,
      });
      console.log("sendAlertViaEmail", data);
      return data;
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  },
);
